import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from 'react-oidc-context';
import { WebStorageStateStore } from 'oidc-client-ts';

const cognitoAuthConfig = {
  authority: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_sgMHVAasC",
  client_id: "142lurdgkn78inlb9qup85bsa0",
  redirect_uri: `${window.location.origin}/callback`,
  response_type: "code",
  scope: "openid email profile",
  post_logout_redirect_uri: window.location.origin,
  loadUserInfo: true, // Carrega informações do usuário do userinfo endpoint
  automaticSilentRenew: true,
  accessTokenExpiringNotificationTimeInSeconds: 120,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  extraQueryParams: {
    lang: "pt-BR" 
  }
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// wrap the application with AuthProvider
root.render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <App />
    </AuthProvider>
  </React.StrictMode>
);


